import Autocomplete from '@material-ui/lab/Autocomplete';
import { isString } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { getTimeZoneOptions, getTimeZoneShortName } from '../../form/FormConstants';
import { AUTO_COMPLETE_DEFAULT, DEFAULT_STYLE_INPUT_PROPS } from '../../../utilities/FormUtilities';

const useStyles = makeStyles(() => ({
    autoComplete: {
        '& .MuiAutocomplete-root': {
            width: 400,
        },
    },
}));

const timeZoneOptions = getTimeZoneOptions();

export function TimeZoneAutocompleter(props) {
    const classes = useStyles();
    const { label, required = false, value = '', onChange } = props;

    return (
        <div className={classes.autoComplete}>
            <Autocomplete
                options={timeZoneOptions}
                autoHighlight
                autoSelect
                disableClearable
                getOptionLabel={(option) =>
                    !option || isString(option) ? `${option}${getTimeZoneShortName(option)}` : option?.pretty
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        {...DEFAULT_STYLE_INPUT_PROPS}
                        label={label}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: AUTO_COMPLETE_DEFAULT,
                            size: 35,
                        }}
                        required={required}
                        value={value}
                    />
                )}
                onChange={onChange}
                getOptionSelected={(option, currentValue) =>
                    option?.name === currentValue || option?.pretty === currentValue
                }
                {...props}
            />
        </div>
    );
}
